<script lang="ts">
	import type { RouteSelectorType } from '$lib/components/route/routeSelector/types';
	import type { Snippet } from 'svelte';
	import type { ClassValue } from 'svelte/elements';

	interface Props {
		listItem: Snippet<[any, number]>;
		header: Snippet;
		list?: RouteSelectorType[];
		error?: string;
		errorItem?: Snippet;
		dataTestId?: string;
		class?: ClassValue;
		isLoading?: boolean;
		emptyListItem?: Snippet;
	}
	const {
		listItem,
		header,
		list,
		error,
		errorItem,
		dataTestId,
		class: classes,
		isLoading = false,
		emptyListItem,
	}: Props = $props();

</script>

<div class="w-full" data-testid={dataTestId}>
	<div class="list-group-header relative px-2 pb-3 grid grid-cols-[minmax(0,1fr)_36px]">
		{@render header?.()}
	</div>
	<ul class={['list-reset', classes]}>
		{#if list && !error && !isLoading && list.length > 0}
			{#each list as item, index (item?.identifier ?? index)}
				<li>
					{@render listItem?.(item, index)}
				</li>
			{/each}
		{:else if !isLoading && !error && list?.length === 0}
			<li>
				{@render emptyListItem?.()}
			</li>
		{:else if isLoading}
			{#each [1, 2, 3] as item, index (index)}
				<li>
					{@render listItem?.(item, index)}
				</li>
			{/each}
		{:else}
			{@render errorItem?.()}
		{/if}
	</ul>
</div>

<style>
  .list-group-header {
    grid-template-areas:
      'header button'
      'badge button';
  }
</style>
